import React from "react";

const PhotoLibrary = ({inputRef, inputRefCam, handlePhotoChange, datatestid}) => {

  const handleFileChange = event => {
    event.preventDefault();
    event.stopPropagation();
    handlePhotoChange(event)
  };

  return (
    <div data-testid={datatestid}>
      <input
        style={{display: 'none'}}
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
      />
      <input
          style={{display: 'none'}}
          ref={inputRefCam}
          type="file"
          accept="image/*"
          capture="user"
          onChange={handleFileChange}
      />
    </div>
  );
};

export default PhotoLibrary;
